module.exports = __webpack_public_path__ + "img/Picture37.9caf70a9.png";